/*
 * Public API Surface of @mmscan/angular-ui/card
 */

export * from './card';
